// extracted by mini-css-extract-plugin
export var auto = "_4m-1";
export var spinner = "_4m-0";